// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__mgkEO","title":"AboutUs_title__lN3Yl","about":"AboutUs_about__wyqoo","left":"AboutUs_left__qrJAI","right":"AboutUs_right__Ui+ld"};